import { Player } from '@lottiefiles/react-lottie-player';
import React, {useContext, useEffect, useRef, useState} from 'react';
import {Outlet, useParams, useSearchParams} from 'react-router-dom';
import loading from "../../_asset/lottie/loading.json"
import loading_casino from "../../_asset/lottie/ready_casino.json"
import {UserContext} from "../_root";
import api, {ApiErrorHandler} from "../../util/api";
import { isMobile } from 'react-device-detect';
import isDevMode from "../../util/isDevMode";
import swal from "sweetalert";

export default function GameWindowRoot(){
    return (
        <div className={'game-window-layout'}>
            <Outlet/>
        </div>
    )
}

interface getDataInterface {
    type: string,
    uid: string,
    vendor: string
}
export function GameWindow() {
    const {User, UserAuth} = useContext(UserContext)

    const params = useParams();
    const [location] = useSearchParams();

    const [gameData, setGameData] = useState<getDataInterface>({
        type: location.get('type') || "",
        uid: location.get('uid') || "",
        vendor: location.get('vendor') || ""
    })
    const [debuggerCheck, setDebuggerCheck] = useState<boolean>(true)
    const [openUrl, setOpenUrl] = useState<string>("")

    // setGameData({
    //     type: location.get('type') || "",
    //     uid: location.get('uid') || "",
    //     vendor: location.get('vendor') || ""
    // })
    // function detectDevTool(allow: number | undefined): void {
    //     if (!allow || isNaN(+allow)) allow = 100;
    //     const start = +new Date();
    //     // debugger;
    //     const end = +new Date();
    //     if (isNaN(start) || isNaN(end) || end - start > allow) {
    //         // 개발자 도구가 open 된 것을 감지했을 때 실행할 코드 삽입
    //         setDebuggerCheck(true)
    //         console.log('개발자 도구가 감지되었습니다.');
    //     }else{
    //         setDebuggerCheck(false)
    //     }
    // }
    // useEffect(()=> {
    //     detectDevTool(undefined)
    // }, [])
    // useEffect(() => {
    //     if(!debuggerCheck){
    //         setGameData({
    //             type: location.get('type') || "",
    //             uid: location.get('uid') || "",
    //             vendor: location.get('vendor') || ""
    //         })
    //     }
    // }, [debuggerCheck]);
    useEffect(()=> {
        let openUrl: string;
        if(isDevMode()){
            if(isMobile){
                openUrl = "https://mobile.slot-cu88.com/";
            }else{
                openUrl = "https://slot-cu88.com/";
            }
        }else{
            openUrl = window.location.origin
        }
        if(gameData.uid && gameData.vendor){
            if(gameData.type == 'casino'){
                let responseAPIUrl = `/api/game/lobbies/link/honor?vendor=${gameData.vendor}&id=${gameData.uid}`
                if(gameData.vendor == 'evolution I') {
                    responseAPIUrl = `/api/game/lobbies/link/oracle?vendor=${gameData.vendor}&id=${gameData.uid}`
                }
                api(responseAPIUrl)
                    .then(res => res.json())
                    .then((data: {link: string}) => {
                        if(data?.link){
                            openUrl = data.link
                            setOpenUrl(openUrl)
                        }
                    })
                    .catch((res: Response)=> {
                        ApiErrorHandler(res, ()=> {
                            window.close()
                        })
                        // swal({
                        //     text: "현재 이용 불가능 한 게임사 입니다.",
                        //     icon: "error",
                        // }).then(function(){
                        //     window.close()
                        // })
                    })
            }else{
                if(params.vendor == 'PragmaticPlay J'){
                    openUrl += `/api/game/games/link/pragmatic?uid=${gameData.uid}`
                }else{
                    openUrl += `/api/game/games/link/honor?uid=${gameData.uid}&vendor=${gameData.vendor}`
                    // openUrl += `/api/game/games/link/test?uid=${gameData.uid}&vendor=${gameData.vendor}`
                }
                setOpenUrl(openUrl)
            }
        }else{
            alert('정상적인 접근이 아닙니다.')
            window.close()
        }
    }, [gameData])

    // const handleContextMenu = (e) => {
    //
    // }
    useEffect(() => {
        resizeViewportSet();
        window.addEventListener("resize", resizeViewportSet);

        return () => window.removeEventListener("resize", resizeViewportSet);
    }, []);
    return (
        <>
            {
                User && !UserAuth
                    ? <>
                        <p>로그아웃 되었습니다.</p>
                    </>
                    : openUrl
                        ? <iframe className={'iframe-game-window a'}
                                  onLoad={resizeViewportSet}
                                  // onContextMenu={handleContextMenu}
                                  src={openUrl}
                                  frameBorder="0"></iframe>
                        : <>
                            <Player src={loading_casino} loop autoplay></Player>
                            <p>게임을 불러오는 중 입니다...</p>
                        </>
            }

        </>
    );
}

function resizeViewportSet(){
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}